export const locale = {
    lang: 'es',
    data: {
         "USER": "USUARIO",
         "PASSAWORD" : "CLAVE",
         "REMBEMBER" : "Recuérdame",
         "RECUPERAR" : "¿Se te olvidó tu contraseña?",
         "LOGIN": "ENVIAR",
         "MENSAJES": "El sistema se cierra en",
         "BUTTONVOLVER": "Cancelar",
         "BUTTONCONFIRMAR": "Confirmar",
         "MENSAJERECUPERA": "RECUPERA TU CONTRASEÑA",
         "DNI": "Documento de Identidad",
         "ENVIARPassword": "ENVIAR",
         "VOLVERLOGIN": "INICIAR SESIÓN",
   }     
};  
